import type { HTMLAttributes, PropsWithChildren, Ref } from 'react';
import { forwardRef, memo } from 'react';

import styles from './Backdrop.module.scss';

type BackdropProps = Pick<HTMLAttributes<HTMLDivElement>, 'onClick'>;

const Backdrop = memo(
  forwardRef(
    ({ onClick, children }: PropsWithChildren<BackdropProps>, ref: Ref<HTMLDivElement>) => {
      return (
        <div className={styles['backdrop']} onClick={onClick} ref={ref}>
          {children}
        </div>
      );
    },
  ),
);

export { Backdrop };
